import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Modal as ChakraModal
} from '@chakra-ui/react';
import { Summary } from './Summary';
import React from 'react';

export function ModalFiltros({ data, loading, filtroPorPrazo, filtroPorEntrega }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button onClick={onOpen} size="sm" mr={2}>+ Informações</Button>

      <ChakraModal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <h1>Recebimento de Materiais</h1>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center">
            <Summary
              data={data}
              loading={loading}
              filtroPorPrazo={filtroPorPrazo}
              onClose={onClose}
              filtroPorEntrega={filtroPorEntrega}
            />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </ChakraModal>
    </>
  );
}
